
import { Vue, Component, Prop } from "vue-property-decorator";
import DownloadExport from "@/components/DownloadExport.vue";
import Loader from "@/components/Loader.vue";

@Component({ components: { DownloadExport, Loader } })
export default class Download extends Vue {
  @Prop({ required: true })
  id!: string;

  leitungNr: number | null = null;

  get leitungPredefined() {
    return parseInt(this.id) == 2511510500;
  }

  get defaultRules(): ((v: any) => boolean | string)[] {
    return [v => !!v || "Erforderliche Angabe"];
  }

  get where() {
    const lnr = this.leitungPredefined ? 23 : this.leitungNr;
    return [
      "messst_nr=" + this.id,
      ...(lnr === null ? [] : ["leitung_nr=number:" + lnr])
    ];
  }

  onParameterDatenLoaded(params: any[]) {
    if (params.length > 0 && !params.includes(this.leitungNr)) {
      // set default value to first entry
      this.leitungNr = params[0];
    }
  }
}
